export default "__VITE_ASSET__V5$ULzmn__"